module.exports = __webpack_public_path__ + "img/Gem.e38cf064.png";